<!--
 * @Descripttion: 
 * @version: 
 * @Author: lzs
 * @Date: 2022-05-27 19:23:57
 * @LastEditors: Do not edit
 * @LastEditTime: 2022-05-31 15:23:39
-->
<template>
  <div class="drawer">
    <div class="title" v-if="title">{{ title }}</div>
    <div class="drawer-box">
      <div class="level" v-for="(item, index) in drawerList" :key="index">
        <span class="name">{{ item.name }}</span>
        <span class="value"
          >{{ item.value | formatterNum }} <img :src="high"
        /></span>
      </div>
    </div>
  </div>
</template>

<script>
import high from "../../../assets/image/index/rise.png";
import low from "../../../assets/image/index/low.png";
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    drawerList: {
      type: Array,
      default: () => {
        return [
          { name: "昨日用电量", value: 515151551515 },
          { name: "昨日用电量", value: 515151551515 },
          { name: "昨日用电量", value: 515151551515 },
        ];
      },
    },
  },
  data() {
    return {
      high,
      low,
    };
  },
  filters: {
    formatterNum(value) {
      if (value === "-") return value;
      if (typeof value === "number") return value.toLocaleString();
    },
  },
};
</script>

<style scoped lang="scss">
.drawer {
  width: 100%;
  height: 100%;
  &:not(:first-child) {
    margin-top: 6px;
  }
  .title {
    font-size: 14px;
    text-align: left;
    padding: 10px 0 12px 9px;
    box-sizing: border-box;
  }
  .drawer-box {
    width: 100%;
    height: 100%;
    .level {
      height: 40px;
      line-height: 40px;
      display: flex;
      font-size: 14px;
      border: 1px solid #37539d;
      border-bottom: none;
      &:last-child {
        border-bottom: 1px solid #37539d;
      }
      span {
        width: 50%;
        img {
          margin-left: 10px;
        }
      }
      .value {
        text-align: left;
        font-weight: bold;
        padding-left: 19px;
      }
      .name {
        border-right: 1px solid #37539d;
        background-color: #00368e;
      }
    }
  }
}
</style>
